export const PADDLE_PROVIDERS = Object.freeze({
  CLASSIC: 'paddle',
  BILLING: 'paddle_billing'
})

export const PADDLE_BILLING_SDK_URL =
  'https://cdn.paddle.com/paddle/v2/paddle.js'

export const PADDLE_BILLING_SCRIPT_SELECTOR =
  'script[data-paddle-billing="true"]'

export const PADDLE_ENVIRONMENTS = Object.freeze({
  SANDBOX: 'sandbox'
})

export const PADDLE_BILLING_EVENTS = Object.freeze({
  CHECKOUT_COMPLETED: 'checkout.completed',
  CHECKOUT_PAYMENT_COMPLETED: 'checkout.payment.completed',
  CHECKOUT_CLOSED: 'checkout.closed',
  CHECKOUT_ERROR: 'checkout.error',
  CHECKOUT_PAYMENT_FAILED: 'checkout.payment.failed'
})

export const PADDLE_CHECKOUT_DISPLAY_MODES = Object.freeze({
  INLINE: 'inline',
  OVERLAY: 'overlay'
})

export const PADDLE_CHECKOUT_THEMES = Object.freeze({
  LIGHT: 'light'
})

export const PADDLE_CHECKOUT_VARIANTS = Object.freeze({
  EXPRESS: 'express'
})

// Default inline checkout frame height (px) shared by all Billing inline checkouts.
export const PADDLE_INLINE_FRAME_HEIGHT = 416
